import * as yup from 'yup';
// New simplified chart schema
export const chartLinkSchema = yup.object({
    templateId: yup.string().required(),
    placeholder: yup.string().required(),
    ranges: yup.array(yup.object({
        range: yup.string().required(), // e.g. "A1:B5"
        values: yup.array(yup.array(yup.mixed())).required() // 2D array of values
    })).required()
});
// Updated createReportRequest schema
export const createReportRequest = yup.object({
    texts: yup.object().optional().test('is-string-keys', 'Texts must have string keys', obj => Object.keys(obj || {}).every(key => typeof key === 'string')),
    images: yup.object().optional().test('is-string-keys', 'Images must have string keys', obj => Object.keys(obj || {}).every(key => typeof key === 'string')),
    templateId: yup.string().required(),
    charts: yup.array(chartLinkSchema).required(),
    eventName: yup.string().required(),
    templateName: yup.string().required(),
    reportDate: yup.string().required(),
});
// Updated createReportResponse schema
export const createReportResponse = yup.object({
    url: yup.string().required(),
    googleSlidesId: yup.string().required(),
    chartsGoogleSheetsId: yup.string().optional(),
});
export const errorResponseSchema = yup.object({
    error: yup.string().required(),
});
export const reportExportRequestSchema = yup.object({
    googleSlidesId: yup.string().required(),
    format: yup.string().oneOf(['png', 'pdf']).required(),
});
export const reportIssueRequestSchema = yup.object({
    message: yup
        .string()
        .required('message is required')
        .trim()
        .min(1, 'message must not be empty'),
    screenshotPngBase64: yup
        .string()
        .strict()
        .nullable()
        .notRequired()
        .max(2000000, 'screenshotPngBase64 exceeds maximum length')
        .test('raw-base64', 'screenshotPngBase64 must be raw base64 without a data: URL prefix', (value) => value == null || value === undefined || !value.startsWith('data:')),
    consoleLogs: yup.array(yup.string().required()).required('consoleLogs is required'),
    userAgent: yup.string().required('userAgent is required'),
    platform: yup.string().required('platform is required'),
    viewport: yup
        .object({
        width: yup.number().required('viewport width is required'),
        height: yup.number().required('viewport height is required'),
    })
        .required('viewport is required'),
    url: yup.string().required('url is required'),
    appVersion: yup.string().required('appVersion is required'),
    userEmail: yup.string().required('userEmail is required'),
});
export const reportIssueResponseSchema = yup.object({
    issueUrl: yup.string().required('issueUrl is required'),
});
export const reportIssueStatusResponseSchema = yup.object({
    ok: yup.boolean().strict().required().oneOf([true]),
});
